exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nuxt-progress {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  height: 2px;\n  width: 0%;\n  opacity: 1;\n  -webkit-transition: width 0.1s, opacity 0.4s;\n  transition: width 0.1s, opacity 0.4s;\n  background-color: #3B8070;\n  z-index: 999999;\n}\n.nuxt-progress.nuxt-progress-notransition {\n  -webkit-transition: none;\n  transition: none;\n}\n.nuxt-progress-failed {\n  background-color: red;\n}\n", ""]);

// exports
